import {LinkPlugin as LexicalLinkPlugin} from '@lexical/react/LexicalLinkPlugin';
import {validateUrl} from '../utils/validateUrl';

export default function LinkPlugin(): JSX.Element {
    return <LexicalLinkPlugin validateUrl={validateUrl} />;
}
